import { useOwnerPropertyLoginMutation } from '@alluradirect/react';
import { useCreatePropertyMutation } from 'hooks/api/property/mutations/useCreatePropertyMutation';
import { useListPageModalNavigation } from './useListPageModalNavigation';

export const useListPropertyCreateMutation = () => {
  const propertyLoginMutation = useOwnerPropertyLoginMutation();
  const { pushOnboarding } = useListPageModalNavigation();

  return useCreatePropertyMutation({
    onSuccess: ({ DATA }) => {
      const {
        PROPERTY_ID,
        PROPERTY: {
          OWNER: { ID },
        },
      } = DATA;

      propertyLoginMutation.mutate(
        {
          id: ID,
          property_id: PROPERTY_ID,
        },
        {
          onSuccess: () => {
            // Send an email to the owner.
            // The email will include a link to onboarding. If the user has
            // requested assisted setup, the email will also include a param to note this.
            // However, we need to ensure that the entry in the DB with the URL is saved
            // before we send this email since the DB entry is the only way to know if the
            // user requested assisted set up. This is not a huge deal, since the only thing it impacts
            // is the opening modal in onboarding. This is very much a nice to have.
            // this is currently sent from Lucee app
            // createPropertyEmailMutation.mutate({ property_id: PROPERTY_ID });
            pushOnboarding(PROPERTY_ID);
          },
        },
      );
    },
  });
};
